<template>
  <div class="samplesDiagnosisView">
    <b-row class="h-100">
      <b-col
        xl="2"
        lg="2"
        class="p-0 h-100"
        :class="[showSample ? 'sample-col' : 'sample-compact-col', !showSample]"
      >
        <b-card class="sample-content component-bg">
          <div class="sample-section">
            <samples-cards
              id="samplesCards"
              ref="samplesCards"
              :laboratory-id="labId"
              :case-id="casId"
              :sample-id="selectedSamId"
              :route-is-diagnosis="routeIsDiagnosis"
              class="mx-2"
              :show-compact-view="!showSample"
              @showIncidentsModal="$emit('showIncidentsModal', {coreEntity: 'SAMPLE', casId: casId, samId: $event})"
              @show-sample-attachment-tree-modal="$emit('show-sample-attachment-tree-modal', $event)"
              @showReviewInfoModal="onRevisionClick($event)"
              @cardSelected="checkChangesInActiveTabAndApplyAction(() => selectCard($event))"
            />
          </div>
          <div
            slot="footer"
            class="d-flex justify-content-end"
          >
            <b-button
              v-if="showSample"
              v-shortkey="['f2']"
              qa="samples-diagnosis-samples-compact-button"
              class="btn__icon btn__icon--primary px-2"
              @shortkey.prevent="hideSampleCard"
              @click="hideSampleCard"
            >
              <i
                class="far fa-chevron-left"
                aria-hidden="true"
              />
            </b-button>
            <b-button
              v-else
              v-shortkey="['f2']"
              qa="samples-diagnosis-samples-expand-button"
              class="btn__icon btn__icon--primary px-2"
              @shortkey.prevent="showSampleCard"
              @click="showSampleCard"
            >
              <i
                class="far fa-chevron-right"
                aria-hidden="true"
              />
            </b-button>
          </div>
        </b-card>
      </b-col>
      <b-col class="data-col h-100">
        <b-card class="section-col component-bg left-bordered">
          <div class="section-col_container">
            <b-row class="section-col_row h-100">
              <b-col class="diagnosis-content h-100">
                <!--Tabs section-->
                <b-tabs
                  v-if="selectedSamId"
                  :key="selectedSamId"
                  v-model="activeTabIndex"
                  class="vt-tabs--vertical h-100"
                  content-class="h-100"
                  pills
                  card
                  vertical
                >
                  <b-tab
                    ref="macroTab"
                    title-item-class="manuallyControlledTab"
                  >
                    <template slot="title">
                      <i
                        qa="samples-diagnosis-macroscopy-section-i"
                        class="section-icon far fa-align-justify"
                        aria-hidden="true"
                      />
                      <div
                        v-if="sectionsSummary && sectionsSummary.macroHasData"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '1']"
                      class="p-2 section-content"
                      @shortkey.prevent="shortKeyPressed(MACRO_TAB_INDEX)"
                    >
                      <section-macro
                        v-if="activeTabIndex === MACRO_TAB_INDEX"
                        ref="macroSection"
                        :active-tab-index="MACRO_TAB_INDEX"
                        :lab-id="labId"
                        :cas-id="casId"
                        :sample="selectedSample"
                        :disabled="!$_isCaseEditable(caseStudy && caseStudy.status.code)"
                        @reloadSummary="getSectionsSummary"
                      />
                    </div>
                  </b-tab>
                  <b-tab
                    ref="microTab"
                    title-item-class="manuallyControlledTab"
                  >
                    <template slot="title">
                      <i
                        qa="samples-diagnosis-microscopy-section-i"
                        class="section-icon fal fa-microscope"
                        aria-hidden="true"
                      />
                      <div
                        v-if="sectionsSummary && sectionsSummary.microHasData"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '2']"
                      class="p-2 section-content"
                      @shortkey.prevent="shortKeyPressed(MICRO_TAB_INDEX)"
                    >
                      <section-micro
                        v-if="activeTabIndex === MICRO_TAB_INDEX"
                        ref="microSection"
                        :lab-id="labId"
                        :cas-id="casId"
                        :sample="selectedSample"
                        :disabled="!$_isCaseEditable(caseStudy && caseStudy.status.code)"
                        @reloadSummary="getSectionsSummary"
                      />
                    </div>
                  </b-tab>
                  <!--TODO: Volvemos a activar esta sección momentáneamente -->
                  <b-tab
                    ref="assaysEvaluationTab"
                    title-item-class="manuallyControlledTab"
                  >
                    <template slot="title">
                      <i
                        qa="samples-diagnosis-evaluation-section-i"
                        class="section-icon fal fa-tasks-alt"
                        aria-hidden="true"
                      />
                      <div
                        v-if="hasAssaysEvaluation"
                        class="section-bubble"
                      />
                      <div class="section-bubble d-none" />
                    </template>
                    <div
                      v-shortkey="['ctrl', '3']"
                      class="p-2 section-content-grid"
                      @shortkey.prevent="shortKeyPressed(ASSAYS_EVALUATION_TAB_INDEX)"
                    >
                      <assays-evaluations-grid
                        v-if="activeTabIndex === ASSAYS_EVALUATION_TAB_INDEX"
                        ref="assaysEvaluationSection"
                        :laboratory-id="labId"
                        :case-id="casId"
                        :sample-id="selectedSample.samId"
                      />
                      <!--                                            <section-evaluation v-if="activeTabIndex === ASSAYS_EVALUATION_TAB_INDEX" ref="assaysEvaluationSection" :lab-id="labId" :cas-id="casId" :sample="selectedSample"></section-evaluation>-->
                    </div>
                  </b-tab>
                  <b-tab
                    ref="subportionTab"
                    title-item-class="manuallyControlledTab"
                  >
                    <template slot="title">
                      <i
                        qa="samples-diagnosis-subportions-section-i"
                        class="section-icon icon-porta"
                        aria-hidden="true"
                      />
                      <div
                        v-if="hasPortions"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '4']"
                      class="p-2 h-100"
                      @shortkey.prevent="shortKeyPressed(SUBPORTION_TAB_INDEX)"
                    >
                      <section-subportions
                        v-if="activeTabIndex === SUBPORTION_TAB_INDEX"
                        ref="subportionSection"
                        :lab-id="labId"
                        :cas-id="casId"
                        :sam-id="selectedSamId"
                        :case-collapsed="caseCollapsed"
                        @showReviewModal="showReviewModal(...$event)"
                        @showReviewInfoModal="onRevisionClick($event)"
                        @showAssayModal="showAssayModal"
                        @showIncidentsModalForSubportion="$emit('showIncidentsModalForSubportion', $event)"
                        @showSubportionAttachmentTreeModal="$emit('showSubportionAttachmentTreeModal', $event)"
                        @openIncidentFormModal="$emit('openIncidentFormModal', $event)"
                        @openAddFileModalForPortion="$emit('openAddFileModalForPortion', $event)"
                        @openAddFileModalForSubportion="$emit('openAddFileModalForSubportion', $event)"
                      />
                    </div>
                  </b-tab>
                  <b-tab
                    ref="diagnosisTab"
                    title-item-class="manuallyControlledTab"
                  >
                    <template slot="title">
                      <i
                        qa="samples-diagnosis-diagnosis-section-i"
                        class="section-icon fal fa-comment-alt-medical"
                        aria-hidden="true"
                      />
                      <div
                        v-if="sectionsSummary && sectionsSummary.diagnosisHasData"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '5']"
                      class="p-2 section-content"
                      @shortkey.prevent="shortKeyPressed(DIAGNOSIS_TAB_INDEX)"
                    >
                      <section-diagnosis
                        v-if="activeTabIndex === DIAGNOSIS_TAB_INDEX"
                        ref="diagnosisSection"
                        :lab-id="labId"
                        :cas-id="casId"
                        :sample="selectedSample"
                        :disabled="!$_isCaseEditable(caseStudy && caseStudy.status.code)"
                        @reloadSummary="getSectionsSummary"
                      />
                    </div>
                  </b-tab>
                  <b-tab
                    ref="additionalTab"
                    title-item-class="manuallyControlledTab"
                  >
                    <template slot="title">
                      <i
                        qa="samples-diagnosis-comprehensive-diagnosis-section-i"
                        class="section-icon fal fa-files-medical"
                        aria-hidden="true"
                      />
                      <div
                        v-if="sectionsSummary && sectionsSummary.additionalReportHasData"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '6']"
                      class="p-2 section-content"
                      @shortkey.prevent="shortKeyPressed(ADDITIONAL_TAB_INDEX)"
                    >
                      <section-additional
                        v-if="activeTabIndex === ADDITIONAL_TAB_INDEX"
                        ref="additionalSection"
                        :lab-id="labId"
                        :cas-id="casId"
                        :sample="selectedSample"
                        :disabled="!$_isCaseEditable(caseStudy && caseStudy.status.code)"
                        @reloadSummary="getSectionsSummary"
                      />
                    </div>
                  </b-tab>
                  <b-tab
                    ref="codificationsTab"
                    title-item-class="manuallyControlledTab"
                  >
                    <template slot="title">
                      <i
                        qa="samples-diagnosis-codifications-section-i"
                        class="section-icon fal fa-project-diagram"
                        aria-hidden="true"
                      />
                      <div
                        v-if="sectionsSummary && sectionsSummary.hasCodifications"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '7']"
                      class="p-2 section-content-grid"
                      @shortkey.prevent="shortKeyPressed(CODIFICATIONS_TAB_INDEX)"
                    >
                      <section-codifications
                        v-if="activeTabIndex === CODIFICATIONS_TAB_INDEX"
                        ref="codificationsSection"
                        :disabled="!$_isCaseEditable(caseStudy && caseStudy.status.code)"
                        :codifications-service="sampleCodificationServices"
                        :parent-entity-ids-array="[labId, casId, selectedSamId]"
                        :can-edit-codifications="$_canEditSample()"
                        @reloadSummary="getSectionsSummary"
                      />
                    </div>
                  </b-tab>
                  <b-tab
                    ref="observationsTab"
                    title-item-class="manuallyControlledTab"
                  >
                    <template slot="title">
                      <i
                        qa="samples-diagnosis-observations-section-i"
                        class="section-icon fal fa-eye"
                        aria-hidden="true"
                      />
                      <div
                        v-if="sectionsSummary && sectionsSummary.hasObservations"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '8']"
                      class="p-2 h-100"
                      @shortkey.prevent="shortKeyPressed(OBSERVATIONS_TAB_INDEX)"
                    >
                      <section-observations
                        v-if="activeTabIndex === OBSERVATIONS_TAB_INDEX"
                        ref="observationsSection"
                        :lab-id="labId"
                        :cas-id="casId"
                        :sam-id="selectedSamId"
                        :disabled="!$_isCaseEditable(caseStudy && caseStudy.status.code)"
                        @reloadSummary="getSectionsSummary"
                      />
                    </div>
                  </b-tab>
                  <b-tab
                    ref="sampleTab"
                    title-item-class="manuallyControlledTab"
                  >
                    <template slot="title">
                      <i
                        qa="samples-diagnosis-sample-section-i"
                        class="section-icon fal fa-prescription-bottle"
                        aria-hidden="true"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '9']"
                      class="p-2 h-100"
                      @shortkey.prevent="shortKeyPressed(SAMPLE_TAB_INDEX)"
                    >
                      <section-sample
                        v-if="activeTabIndex === SAMPLE_TAB_INDEX"
                        ref="sampleSection"
                        :lab-id="labId"
                        :case-study="caseStudy"
                        :sample="selectedSample"
                        @updateSamplesCards="onUpdateSamplesCards()"
                        @updateCase="$emit('updateCase')"
                        @openAddFileModal="$emit('openAddFileModalForSample', $event)"
                        @openIncidentFormModal="$emit('openIncidentFormModal', $event)"
                      />
                    </div>
                  </b-tab>
                  <!--Sample icons-->
                  <template #tabs-end>
                    <div class="vt-tabs--vertical vt-tabs--vertical__footer">
                      <ul>
                        <div>
                          <li
                            v-if="$_canEditSample()"
                            class="active d-flex align-items-center justify-content-center"
                          >
                            <b-button
                              qa="samples-diagnosis-preformated-button"
                              :disabled="!$_isCaseEditable(caseStudy && caseStudy.status.code)"
                              class="btn__icon btn__icon--primary"
                              @click="showPreformattedModal"
                            >
                              <i
                                v-tooltip="{ title: $tc('diagnosis.btns.preformatted'), placement: 'right', boundary: 'viewport' }"
                                class="far fa-copy"
                                aria-hidden="true"
                              />
                            </b-button>
                          </li>
                          <li
                            v-if="canRequestRevision"
                            class="active d-flex align-items-center justify-content-center"
                          >
                            <b-button
                              qa="samples-diagnosis-review-button"
                              :disabled="!$_isCaseEditable(caseStudy && caseStudy.status.code)"
                              class="btn__icon btn__icon--primary"
                              @click="showReviewModal(selectedSample, ENTITY_TYPE_SAMPLE)"
                            >
                              <i
                                v-tooltip="{ title: $tc('diagnosis.btns.review'), placement: 'right', boundary: 'viewport' }"
                                class="far fa-tasks"
                                aria-hidden="true"
                              />
                            </b-button>
                          </li>
                          <li class="active d-flex align-items-center justify-content-center">
                            <b-button
                              v-shortkey="['alt', 'a']"
                              qa="samples-diagnosis-assays-button"
                              class="btn__icon btn__icon--primary"
                              @shortkey.prevent="showAssayModal"
                              @click="showAssayModal"
                            >
                              <i
                                v-tooltip="{ title: $tc('global.technique', 2), placement: 'right', boundary: 'viewport' }"
                                class="fas fa-flask"
                                aria-hidden="true"
                              />
                            </b-button>
                          </li>
                          <!-- TODO: Comment for future development -->
                          <!--<li class="active d-flex align-items-center justify-content-center">
                                                                <b-button qa="samples-diagnosis-shipments-button"
                                                                          class="btn__icon btn__icon&#45;&#45;primary">
                                                                    <i
                                                                        v-tooltip="{ title: $tc('shipments.actions.checkToSend'), placement: 'right', boundary: 'viewport' }"
                                                                        class="far fa-box" aria-hidden="true">
                                                                    </i>
                                                                </b-button>
                                                            </li>-->
                          <!--<li class="active d-flex align-items-center justify-content-center">
                                                                <b-button
                                                                    class="btn__icon btn__icon&#45;&#45;primary">
                                                                    <i
                                                                        v-tooltip="{ title: $tc('diagnosis.btns.issueNotification'), placement: 'right', boundary: 'viewport' }"
                                                                        class="far fa-envelope" aria-hidden="true">
                                                                    </i>
                                                                </b-button>
                                                            </li>-->
                        </div>
                      </ul>
                    </div>
                  </template>
                </b-tabs>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <bill-modal
      id="billModal"
      ref="billModal"
    />
    <modal-wrapper ref="preformattedModalWrapper">
      <preformatted-modal
        v-if="selectedSample && sectionsSummary"
        ref="preformattedModal"
        :sections-summary="sectionsSummary"
        :cas-id="casId"
        :sam-id="selectedSamId"
        @preformattedApplied="onPreformattedApplied"
      />
    </modal-wrapper>
    <modal-wrapper ref="reviewModalWrapper">
      <review-modal
        :logged-laboratory-id="labId"
        :case-id="casId"
        :sample-id="selectedSampleId"
        :sample-grossing-responsible="selectedSampleGrossingResponsible"
        @revisionCreated="onRevisionCreated($event)"
      />
    </modal-wrapper>
    <modal-wrapper ref="reviewInfoModalWrapper">
      <review-info-modal
        :laboratory-id="labId"
        :case-id="casId"
      />
    </modal-wrapper>
    <assays-view-modal
      v-if="casId"
      ref="assayModal"
      :cas-id="casId"
      :priority-cas="casPriority"
      @subportionsAdded="onAssaysViewModalSubportionsAdded"
      @subportionsUpdates="onAssaysViewModalSubportionsAdded"
    />
    <modal-unsaved-changes
      id="samplesDiagnosisUnsavedChangesModal"
      ref="unsavedChangesModal"
    />
  </div>
</template>

<script>
import sampleCodificationServices from '@/api/resources/samples/sampleCodificationServices'
import SamplesCards from '@/components/samplesCards/SamplesCards'
import SectionMacro from '@/modules/diagnosisModule/views/form/samplesView/sections/SectionMacro'
import SectionMicro from '@/modules/diagnosisModule/views/form/samplesView/sections/SectionMicro'
import SectionSample from '@/modules/diagnosisModule/views/form/samplesView/sections/SectionSample'
import SectionSubportions from '@/modules/diagnosisModule/views/form/samplesView/sections/subportions/SectionSubportions'
import SectionDiagnosis from '@/modules/diagnosisModule/views/form/samplesView/sections/SectionDiagnosis'
import SectionAdditional from '@/modules/diagnosisModule/views/form/samplesView/sections/SectionAdditional'
import SectionCodifications from '@/modules/diagnosisModule/views/form/sections/SectionCodifications'
import SectionObservations from '@/modules/diagnosisModule/views/form/samplesView/sections/SectionObservations'
import BillModal from '@/modules/diagnosisModule/views/form/modals/BillModal'
import PreformattedModal from '@/modules/diagnosisModule/views/form/modals/PreformattedModal'
import ReviewModal from '@/modules/diagnosisModule/views/form/modals/reviewModal/ReviewModal'
import ReviewInfoModal from '@/modules/diagnosisModule/views/form/modals/reviewModal/ReviewInfoModal'
import AssaysViewModal from '@/components/assays-view/components/modal/assays-view-modal.vue'
import ModalUnsavedChanges from '@/components/modals/ModalUnsavedChanges'
import DiagnosisSampleService from '@/modules/diagnosisModule/services/DiagnosisSampleService'
import { SECTION_TAB_INDEX } from '@/modules/diagnosisModule/views/form/samplesView/sections/constants/sectionsTabIndex'
import sampleRevisionServices from '@/api/resources/common/sampleRevisionServices'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import { REVISION_ENTITY_TYPE } from '@/modules/diagnosisModule/constants/revisionEntityType'
import { SampleOperationGuardMixin } from '@/api/operations/mixins/guards/sample-operation-guard.mixin'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'
import AssaysEvaluationsGrid from '@/modules/diagnosisModule/components/assays-evaluations-grid/assays-evaluations-grid.vue'
import { router } from '@/router'
import { HelperUtils } from '@/shared/util/helper-utils'

export default {
    name: 'SamplesDiagnosis',
    components: {
        AssaysEvaluationsGrid,
        SamplesCards,
        SectionMacro,
        SectionMicro,
        SectionSample,
        SectionSubportions,
        SectionDiagnosis,
        SectionAdditional,
        SectionCodifications,
        SectionObservations,
        BillModal,
        PreformattedModal,
        ReviewModal,
        ReviewInfoModal,
        AssaysViewModal,
        ModalUnsavedChanges
    },
    mixins: [
        SampleOperationGuardMixin,
        CaseOperationGuardMixin
    ],
    props: {
        labId: { type: Number, required: true },
        caseStudy: { type: Object, required: true },
        showSample: { type: Boolean, required: true },
        caseCollapsed: { type: Boolean }
    },
    data() {
        return {
            valueMockup: {
                attachBubble: 3,
                incidentBubble: 2
            },
            sectionsSummary: null,
            selectedSamId: null,
            showCarousel: true,
            activeTabIndex: SECTION_TAB_INDEX.MACRO_TAB_INDEX,
            selectedSample: null,
            message: null,
            sampleHaveUnfinishedRevisions: null
        }
    },
    computed: {
        routeIsDiagnosis() {
            return this.$route.name === 'diagnosisCaseInform'
        },
        casId() { return this.caseStudy.casId },
        casPriority() { return this.caseStudy.priority },
        selectedSampleGrossingResponsible() {
            return this.selectedSample?.grossingResponsible
        },
        selectedSampleLabel() {
            return this.selectedSample ? this.selectedSample.label : ''
        },
        selectedSampleId() {
            return this.selectedSample ? this.selectedSample.samId : null
        },
        ENTITY_TYPE_SAMPLE() {
            return ATTACHMENT_ENTITY_TYPE.SAMPLE
        },
        canRequestRevision() {
            return this.selectedSample.canBeReviewed && this.$_canRequestAnySampleRevision()
        },
        sampleCodificationServices() {
            return sampleCodificationServices
        },
        MACRO_TAB_INDEX() {
            return SECTION_TAB_INDEX.MACRO_TAB
        },
        MICRO_TAB_INDEX() {
            return SECTION_TAB_INDEX.MICRO_TAB
        },
        SUBPORTION_TAB_INDEX() {
            return SECTION_TAB_INDEX.SUBPORTION_TAB
        },
        DIAGNOSIS_TAB_INDEX() {
            return SECTION_TAB_INDEX.DIAGNOSIS_TAB
        },
        ADDITIONAL_TAB_INDEX() {
            return SECTION_TAB_INDEX.ADDITIONAL_TAB
        },
        CODIFICATIONS_TAB_INDEX() {
            return SECTION_TAB_INDEX.CODIFICATIONS_TAB
        },
        OBSERVATIONS_TAB_INDEX() {
            return SECTION_TAB_INDEX.OBSERVATIONS_TAB
        },
        SAMPLE_TAB_INDEX() {
            return SECTION_TAB_INDEX.SAMPLE_TAB
        },
        ASSAYS_EVALUATION_TAB_INDEX() {
            return SECTION_TAB_INDEX.ASSAYS_EVALUATION_TAB
        },
        canReloadTab() {
            return this.activeTabIndex !== this.ASSAYS_EVALUATION_TAB_INDEX &&
                this.activeTabIndex !== SECTION_TAB_INDEX.SUBPORTION_TAB_INDEX &&
                this.activeTabIndex !== SECTION_TAB_INDEX.OBSERVATIONS_TAB_INDEX &&
                this.activeTabIndex !== SECTION_TAB_INDEX.SAMPLE_TAB_INDEX
        },
        hasAssaysEvaluation() {
            return this?.sectionsSummary?.hasAssaysEvaluation
        },
        hasPortions() {
            return this?.sectionsSummary?.hasPortions
        }
    },
    watch: {
        selectedSamId() {
            this.getSectionsSummary()
            this.getSampleUnfinishedRevisions()
        }
    },
    async mounted() {
        await this.$refs.samplesCards.loadSamples()
        if (this.$refs.samplesCards.samples?.length) {
            if (this.$route.params.samId) {
                this.selectSample(this.$route.params.samId)
            } else {
                this.selectSample(this.$refs.samplesCards.samples[0].samId)
            }
        }
        if (this.$route.params.porId) {
            this.activeTabIndex = SECTION_TAB_INDEX.SUBPORTION_TAB
        }
        this.$nextTick(() => {
            this.replaceClickOnTabEvents()
        })
    },
    methods: {
        onAssaysViewModalSubportionsUpdated() {
            this.$refs.subportionSection.loadPortions()
            this.$emit('updateCase')
        },
        onAssaysViewModalSubportionsAdded() {
            this.$refs.subportionSection.loadPortions()
            this.$emit('updateCase')
        },
        async onPreformattedApplied() {
            await this.reloadActiveTab()
            await this.getSectionsSummary()
        },
        hideSampleCard() {
            this.showSample = false
            this.$emit('hideSampleCard', false)
        },
        showSampleCard() {
            this.showSample = true
            this.$emit('showSampleCard', true)
        },
        async onUpdateSamplesCards() {
            await this.$refs.samplesCards.loadSamples()
            this.selectSample(this.selectedSamId)
        },
        async onRevisionCreated(entityType) {
            if (entityType === REVISION_ENTITY_TYPE.SAMPLE) {
                await this.$refs.samplesCards.loadSamples()
                this.selectSample(this.$refs.samplesCards.samples[0].samId)
            } else if (entityType === REVISION_ENTITY_TYPE.SUBPORTION || entityType === REVISION_ENTITY_TYPE.PORTION) {
                await this.$refs.subportionSection.loadPortions()
            }
            this.$emit('updateCase')
        },
        onRevisionClick(event) {
            this.$refs.reviewInfoModalWrapper.show([event.revision, event.entitySelected, event.entityType])
        },
        async getSectionsSummary() {
            const [err, response] = await this.toCall(DiagnosisSampleService.sectionsSummary(this.labId, this.casId, this.selectedSamId))
            if (err) {
                this.showErrorModalGlobal()
            }
            this.sectionsSummary = response
        },
        async reloadActiveTab() {
            if (this.canReloadTab) {
                const activeTab = this.getActiveTabContent()
                await activeTab?.reloadTab()
            }
        },
        selectSample(sampleId) {
            if (this.$refs.samplesCards.samples.length) {
                const foundSample = this.$refs.samplesCards.samples.find(sample => sample.samId === sampleId)
                if (foundSample) {
                    this.selectedSample = foundSample
                    this.selectedSamId = foundSample.samId
                    this.$emit('sampleSelected', foundSample)
                }
            }
        },
        selectCard(sample) {
            this.selectedSamId = sample.samId
            this.selectedSample = sample
            this.$emit('sampleSelected', sample)
            this.$nextTick(() => this.replaceClickOnTabEvents())
        },
        showBillModal() {
            this.$refs.billModal.show()
        },
        async showReviewModal(entitySelected, entityType) {
            this.$refs.reviewModalWrapper.show([entitySelected, entityType])
        },
        showAssayModal(entityLabelToFocus = this.selectedSample.label) {
            const entitiesToFocus = [{ label: entityLabelToFocus }]
            this.$refs.assayModal.show(entitiesToFocus)
        },
        showPreformattedModal() {
            this.$refs.preformattedModalWrapper.show()
        },
        replaceClickOnTabEvents() {
            const tabs = document.getElementsByClassName('manuallyControlledTab')
            if (tabs.length === 0) {
                setTimeout(this.replaceClickOnTabEvents, 100)
                return
            }
            for (let i = 0; i < tabs.length; i++) {
                const tab = tabs.item(i)
                tab.addEventListener('click', this.navigateToTab)
            }
        },
        navigateToTab(mouseEvent) {
            const newTabIndex = Number.parseInt(mouseEvent.currentTarget.children[0].getAttribute('aria-posinset')) - 1
            this.checkChangesInActiveTabAndApplyAction(() => {
                this.activeTabIndex = newTabIndex
            })
        },
        shortKeyPressed(tabIndex) {
            this.checkChangesInActiveTabAndApplyAction(() => {
                this.activeTabIndex = tabIndex
            })
        },
        async checkChangesInActiveTabAndApplyAction(goToRoute, changedLaboratory) {
            const activeTabContent = this.getActiveTabContent()
            if (changedLaboratory) {
                if (!activeTabContent || this.activeTabIndex === this.ASSAYS_EVALUATION_TAB_INDEX) {
                    await HelperUtils.runActionsWhenChangeLaboratory(goToRoute)
                    return
                }
                if (activeTabContent.hasBeenChanged()) {
                    this.$refs.unsavedChangesModal.askAndExecuteCallbacks(
                        activeTabContent.save,
                        async () => {
                            HelperUtils.runActionsWhenChangeLaboratory(goToRoute)
                        },
                        () => { router.currentRoute.meta.skipChecking = false }
                    )
                } else {
                    HelperUtils.runActionsWhenChangeLaboratory(goToRoute)
                }
            } else {
                if (!activeTabContent || this.activeTabIndex === this.ASSAYS_EVALUATION_TAB_INDEX) {
                    goToRoute()
                    return
                }
                if (activeTabContent.hasBeenChanged()) {
                    this.$refs.unsavedChangesModal.askAndExecuteCallbacks(
                        () => { return activeTabContent.save() },
                        goToRoute)
                } else {
                    goToRoute()
                }
            }
        },
        async saveChangesInActiveTabAndApplyAction(actionIfTrue) {
            const activeTabContent = this.getActiveTabContent()
            if (!activeTabContent || this.activeTabIndex === this.ASSAYS_EVALUATION_TAB_INDEX) {
                actionIfTrue()
                return
            }
            if (activeTabContent.hasBeenChanged()) {
                await activeTabContent.save()
                actionIfTrue()
            } else {
                actionIfTrue()
            }
        },
        getActiveTabContent() {
            if (this.activeTabIndex === SECTION_TAB_INDEX.MACRO_TAB) {
                return this.$refs.macroSection
            } else if (this.activeTabIndex === SECTION_TAB_INDEX.MICRO_TAB) {
                return this.$refs.microSection
            } else if (this.activeTabIndex === SECTION_TAB_INDEX.ASSAYS_EVALUATION_TAB) {
                return this.$refs.assaysEvaluationSection
            } else if (this.activeTabIndex === SECTION_TAB_INDEX.SUBPORTION_TAB) {
                return this.$refs.subportionSection
            } else if (this.activeTabIndex === SECTION_TAB_INDEX.DIAGNOSIS_TAB) {
                return this.$refs.diagnosisSection
            } else if (this.activeTabIndex === SECTION_TAB_INDEX.ADDITIONAL_TAB) {
                return this.$refs.additionalSection
            } else if (this.activeTabIndex === SECTION_TAB_INDEX.CODIFICATIONS_TAB) {
                return this.$refs.codificationsSection
            } else if (this.activeTabIndex === SECTION_TAB_INDEX.OBSERVATIONS_TAB) {
                return this.$refs.observationsSection
            } else if (this.activeTabIndex === SECTION_TAB_INDEX.SAMPLE_TAB) {
                return this.$refs.sampleSection
            } else {
                return null
            }
        },
        async getSampleUnfinishedRevisions() {
            this.updateLoading(true)
            const [error, response] = await this.toCall(sampleRevisionServices.getSampleUnfinishedRevision(this.casId, this.selectedSamId, this.labId))
            this.updateLoading(false)
            if (error) {
                if (error.response.status !== 404) {
                    this.showErrorModalGlobalFromErrorResponse(error)
                }
                this.sampleHaveUnfinishedRevisions = false
                return
            }
            this.sampleHaveUnfinishedRevisions = response
        }
    }
}
</script>

<style lang="scss">
    .pop-case {
        padding-left: 0;
        padding-bottom: 0;
        margin-bottom: 0;
        width: 200px;
    }

    .pop-case li {
        list-style: none !important;
        padding: 10px !important;
        border-bottom: 1px solid rgb(218, 218, 218);
    }
    .samplesDiagnosisView .manuallyControlledTab {
        cursor: pointer;
    }

    .samplesDiagnosisView .manuallyControlledTab > a {
        pointer-events: none;
    }

    .samplesDiagnosisView .extra-btns .btn.disabled {
        color: vt-color(base-text, .3) !important;
    }
    .hide-sample-nav-element {
        display: none !important;
    }
    @media only screen and (max-width: 1366px) and (min-width: 1360px){
        .samplesDiagnosisView .laptop-screen {
            display: none !important;
        }
        .hide-sample-nav-element {
            display: block !important;
        }
    }
    @media (max-width: 1250px) {
        .samplesDiagnosisView .laptop-screen {
            display: none !important;
        }
        .hide-sample-nav-element {
            display: block !important;
        }
    }
    @media (max-height: 760px) {
        .samplesDiagnosisView .laptop-screen {
            display: none !important;
        }
        .hide-sample-nav-element {
            display: block !important;
        }
    }
</style>
